import { createSlice } from "@reduxjs/toolkit";
import {useFirebase} from "react-redux-firebase";

let projects = [
    {
        "id": 1,
        "name": "Deventer",
        "description": "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of \"de Finibus Bonorum et Malorum\" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", comes from a line in section 1.10.32.",
        "accessCode": "DEVENTER01",
        "startDate": Date.now(),
        "endDate": Date.now(),
        "radius": 1,
        "isPrivate": false
    },
    {
        "id": 2,
        "name": "Arnhem",
        "description": "This is the description about the Arnhem project and I donno what to write about this so I am going to use Lorem ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        "accessCode": "ARNHEM",
        "radius": 3,
        "startDate": Date.now(),
        "endDate": Date.now(),
        "isPrivate": true
    },
]

const initialState = {
    count: projects.length,
    projects: projects,
    selectedProject: {}
};


export const projectSlice = createSlice({

    name: "project",
    initialState,
    reducers: {
        addProject: (state, action) => {
            const project = {
                id: Math.random() * 100,
                name: action.payload.name,
                description: action.payload.description,
                accessCode: action.payload.accessCode,
            };
            state.projects.push(project);
            state.count += 1;
        },
        removeProject: (state, action) => {
            state.projects = state.projects.filter((project) => project.id !== action.payload);
            state.count -= 1;
        },
        updateSelectedProject: (state, action) => {
            state.selectedProject = action.payload;
        },
    },
});

export const { addProject, removeProject, updateSelectedProject } = projectSlice.actions;
export default projectSlice.reducer;